import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Access Denied"
      subtitle="You don't have permission to access this page."
    >
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Please contact your administrator if you believe you should have access
        to this resource.
      </Typography>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={() => navigate("/")}>
          Go to Dashboard
        </Button>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Box>
    </AuthLayout>
  );
};
